export default __webpack_public_path__ + "static/main-app-templates-2a9c0822dab0ec6e9750ef22d902ee70.png";